import React from 'react';
import type { Consultant, ConsultantTone } from '../../types/content';
interface ConsultantAvatarProps {
  consultant: Consultant;
  size?: 'sm' | 'lg' | 'panel';
}
const toneClasses: Record<ConsultantTone, {
  bg: string;
  text: string;
  line: string;
}> = {
  aubergine: {
    bg: 'bg-aubergine',
    text: 'text-copper-light',
    line: '#D49A7F'
  },
  copper: {
    bg: 'bg-copper',
    text: 'text-white',
    line: '#F8F5F0'
  },
  sage: {
    bg: 'bg-sage',
    text: 'text-porcelain',
    line: '#F8F5F0'
  },
  plum: {
    bg: 'bg-plum',
    text: 'text-copper-light',
    line: '#D49A7F'
  }
};
export function ConsultantAvatar({
  consultant,
  size = 'panel'
}: ConsultantAvatarProps) {
  const tone = toneClasses[consultant.tone];
  const sizing = size === 'sm' ? 'h-12 w-12 rounded-full text-lg' : size === 'lg' ? 'h-44 w-44 rounded-2xl text-6xl' : 'aspect-[4/3] w-full text-6xl';
  return <div role="img" aria-label={`Monogram for ${consultant.name}`} className={`relative flex shrink-0 items-center justify-center overflow-hidden ${tone.bg} ${sizing}`} data-id="element-52" data-mp="3ros4dwmde5gw">
      {size !== 'sm' && <svg className="absolute inset-0 h-full w-full" viewBox="0 0 200 150" preserveAspectRatio="xMidYMid slice" aria-hidden="true" data-id="element-53" data-mp="3v18tlycfovra">
          <line x1="40" y1="150" x2="110" y2="-10" stroke={tone.line} strokeOpacity="0.18" strokeWidth="1" data-id="element-54" data-mp="cnrgsp4um4py" />
          <line x1="120" y1="-10" x2="190" y2="150" stroke={tone.line} strokeOpacity="0.12" strokeWidth="1" data-id="element-55" data-mp="7tn8o2jujqna" />
          <line x1="0" y1="105" x2="200" y2="105" stroke={tone.line} strokeOpacity="0.14" strokeWidth="1" data-id="element-56" data-mp="mmh10ok7w19d" />
        </svg>}
      <span className={`relative font-serif font-medium tracking-wide ${tone.text}`} data-id="element-57" data-mp="vluc1lnzoxw7">{consultant.initials}</span>
    </div>;
}